export default "__VITE_ASSET__9bvL9LQn__"